import { useLocalStorage } from "usehooks-ts"

import { LOCAL_STORAGE_KEYS } from "~config/constants"
import useExpiration from "~utils/use-expiration"

export default function usePersistedWidgetCheckoutParamsString(
    listingId: string | null | undefined
) {
    const [persistedCheckoutSessions, setPersistedCheckoutSessions] =
        useLocalStorage<PersistedWidgetSessions | null>(
            LOCAL_STORAGE_KEYS.WIDGET_SESSIONS,
            null
        )

    const widgetSession = getWidgetCheckoutSession({
        listingId,
        persistedCheckoutSessions,
    })
    const checkoutParamsString = widgetSession?.checkoutParamsString ?? null
    const createdAt = widgetSession?.createdAt ?? null

    const persistCheckoutParamsString = (paramsString: string) => {
        if (!listingId) return

        setPersistedCheckoutSessions({
            ...persistedCheckoutSessions,
            [listingId]: {
                createdAt: Date.now(),
                checkoutParamsString: paramsString,
            },
        })
    }

    const clearCheckoutParamsString = () => {
        if (!listingId) return

        setPersistedCheckoutSessions({
            ...persistedCheckoutSessions,
            [listingId]: null,
        })
    }

    useExpiration({ createdAt, onIsExpired: clearCheckoutParamsString })

    return {
        checkoutParamsString,
        persistCheckoutParamsString,
        clearCheckoutParamsString,
    }
}

function getWidgetCheckoutSession({
    listingId,
    persistedCheckoutSessions,
}: {
    listingId: string | null | undefined
    persistedCheckoutSessions: PersistedWidgetSessions | null
}) {
    if (!listingId) return null

    return persistedCheckoutSessions?.[listingId] ?? null
}

interface PersistedWidgetSessions {
    [listingId: string]: WidgetCheckoutSession | null | undefined
}

interface WidgetCheckoutSession {
    checkoutParamsString: string
    createdAt: number
}
